import { env } from '../../config';
import { cfg } from '../runtime-config';

const isTest = process.env.NODE_ENV === 'test';

export const CDN_ASSETS_BASE = isTest ? 'test' : env.CDN_ASSETS_BASE;

export const OFFER_CDN_URL = isTest ? 'test' : env.OFFER_CDN_URL;

const zuulEnvBase = isTest ? cfg('ZUUL_API_BASE') : (cfg('ZUUL_API_BASE') || env.baseURL);

export const ZUUL_API_BASE = `${zuulEnvBase}v1/`;

export const PAYOUT_SCHEME = {
  5: { id: 5, name: 'Advertiser CPC' },
  2: { id: 2, name: 'CPC' },
  4: { id: 4, name: 'Rev Share' },
  // Pre-ping priced CPC: revenue is the clicked ad's pre-ping bid; no fixed Payout Amount.
  6: { id: 6, name: 'CPC-PP' },
};

export const TRIGGER_TYPES = {
  ON_ANSWER: { id: 1, name: 'ON_ANSWER' },
  Clicked: { id: 2, name: 'ON_CLICK' },
  Impression: { id: 3, name: 'ON_IMPRESSION' },
  'Clicked or skipped': { id: 4, name: 'ON_CLICK_OR_SKIP' },
  post_on_submit: { id: 5, name: 'SUBMIT' },
  post_on_submit_and_param: { id: 6, name: 'SUBMIT+PARAMS' },
  post_on_submit_and_certified_lookup: { id: 7, name: 'SUBMIT+CERTIFIED_LOOKUP' },
  ON_QUESTION_CLICK: { id: 8, name: 'ON_QUESTION_CLICK' },
};

export const DB_TRIGGER_TYPES = {
  ON_ANSWER: { id: 1, name: 'ON_ANSWER' },
  ON_CLICK: { id: 2, name: 'ON_CLICK' },
  ON_IMPRESSION: { id: 3, name: 'ON_IMPRESSION' },
  ON_CLICK_OR_SKIP: { id: 4, name: 'ON_CLICK_OR_SKIP' },
  SUBMIT: { id: 5, name: 'SUBMIT' },
  'SUBMIT+PARAMS': { id: 6, name: 'SUBMIT+PARAMS' },
  'SUBMIT+CERTIFIED_LOOKUP': { id: 7, name: 'SUBMIT+CERTIFIED_LOOKUP' },
  ON_QUESTION_CLICK: { id: 8, name: 'ON_QUESTION_CLICK' },
};
